import React from "react";
import parse from "html-react-parser";

const Check = ({ name, id, value, onChange }: any) => {
  return (
    <div className="flex items-center mb-4">
      <input
        type="checkbox"
        id={id}
        className="w-4 h-4 text-[--primary600]-600 bg-gray-100 border-gray-300 rounded focus:ring-[--primary600]-500 dark:focus:ring-[--primary600]-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        checked={value}
        onChange={(e) => {
          onChange(e.target.checked, id);
        }}
      />
      <div className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
        {parse(name || "")}
      </div>
    </div>
  );
};

export default Check;
